module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.7-96.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.2.1-rc.7.md
// module id = 513
// module chunks = 316